<script>
import {mapState} from "vuex";

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: null,
      income: 35000,
      incomeWithComma: "",
    };
  },

  computed: {
   ...mapState([
      'fieldsFromUrl',
      'fieldsFromStorage',
    ])
  },

  created() {
    if (this.prepare) {
      if (this.fieldsFromUrl['household_income']) {
        this.income = parseInt(this.fieldsFromUrl['household_income'])
      } else if (this.fieldsFromStorage['household_income']) {
        this.income = parseInt(this.fieldsFromStorage['household_income'])
      }

      const valid = this.validate();
      if (valid && (this.fieldsFromUrl['household_income'] || this.fieldsFromStorage['household_income'])) {
        this.setAnswersAndGoToNext()
        return
      }

      this.$emit('show-this-step')
    }
  },

  methods: {
    setAnswer(answer) {
      this.loading = null;
      this.loading = answer;
      this.setAnswersAndGoToNext();
    },

    setAnswersAndGoToNext() {
      if (this.income < 10000) {
        this.income = this.income * 12
      }
      this.$store.dispatch("setAnswers", [
        {
          field: "household_income",
          value: this.income,
        },
      ]);
      this.$emit("next-step");
    },

    validate() {
      if (!this.income || this.income === 0 || !(this.income > 5000 && this.income < 1000000)) {
        return false
      } else {
        return true
      }
    },

    handleChange() {
      let val = String(this.income);
      val = val.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (val === "150,000") {
        val = val + "+";
      }
      this.incomeWithComma = val;
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="has-text-centered item-box">
        <h2 class="question mb-3">
          Depending on your income you may qualify for <span class="subtitle-question" style="font-size: 1.625rem;">government subsidies.</span><br>
          What is your annual household income?
        </h2>
        <form
          class="container is-max-widescreen"
          @submit.prevent="setAnswer('Continue')"
        >
          <h2 class="question pt-5">${{ incomeWithComma }}</h2>
          <b-field class="pt-4">
            <b-slider size="is-large" :min="5000" :max="150000" :step="1000" v-model="income" rounded @input="handleChange" :tooltip="false"></b-slider>
          </b-field>
          <input
            type="submit"
            value="Continue"
            class="submitButton mt-3"
            :loading="loading === 'Continue'"
            :disabled="loading !== null"
          />
        </form>
      </div>
    </div>
  </div>
</template>
